module.exports = __webpack_public_path__ + "static/media/home-exercising-three.9a60c1bd.png";